import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import SettingsPanel from './SettingsPanel';
import {setBackupBeforeWrite, setWriteMode, setBeautify, setAutoFix, toggleMetadataField, setDateFormat} from '../redux/slices/fixMetadataSlice';
import ToggleSwitch from './ToggleSwitch';
import CustomSelect from './CustomSelect';

const FixMetadataSettings = () => {
    const dispatch = useDispatch();
    const { enabledFields, dateFormat, writeMode } = useSelector((state) => state.fixMetadata);

    const metadataFieldsComponent = (
        <div className="metadata-fields-container">
            <div className="metadata-fields-grid">
                {[
                    { key: 'artist', label: 'Artist' },
                    { key: 'title', label: 'Title' },
                    { key: 'album', label: 'Album' },
                    { key: 'albumArtist', label: 'Album Artist' },
                    { key: 'label', label: 'Label' },
                    { key: 'releaseDate', label: 'Release Date' },
                    { key: 'genre', label: 'Genre' },
                    { key: 'bpm', label: 'BPM' },
                    { key: 'key', label: 'Key' }
                ].map((field) => (
                    <div key={field.key} className="loudness-label-tooltip-container">
                        <ToggleSwitch
                            id={`field-${field.key}`}
                            checked={enabledFields[field.key]}
                            onChange={() => dispatch(toggleMetadataField(field.key))}
                            label={field.label}
                        />
                    </div>
                ))}
            </div>
        </div>
    );

    const writeModeComponent = (
        <div className="loudness-label-tooltip-container" style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#999' }}>Existing Tags</label>
            <CustomSelect
                value={writeMode}
                onChange={(e) => dispatch(setWriteMode(e.target.value))}
                className="organizer-select"
                options={[
                    { value: 'fillEmpty', label: 'Only fill empty fields' },
                    { value: 'overwriteText', label: 'Overwrite text, keep keys' },
                    { value: 'overwriteAll', label: 'Overwrite everything' }
                ]}
            />
        </div>
    );

    const dateFormatComponent = (
        <div className="loudness-label-tooltip-container" style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#999' }}>Date Format</label>
            <CustomSelect
                value={dateFormat}
                onChange={(e) => dispatch(setDateFormat(e.target.value))}
                className="organizer-select"
                options={[
                    { value: 'fullDate', label: 'Full Date (YYYY-MM-DD)' },
                    { value: 'monthAndYear', label: 'Month & Year (YYYY-MM)' },
                    { value: 'year', label: 'Year Only (YYYY)' },
                    { value: 'dmyDot', label: 'Day.Month.Year (DD.MM.YYYY)' },
                    { value: 'dmySlash', label: 'Day/Month/Year (DD/MM/YYYY)' },
                    { value: 'mdySlash', label: 'Month/Day/Year (MM/DD/YYYY)' }
                ]}
            />
        </div>
    );

    const settings = [
        {
            id: 'beautify',
            selector: 'beautify',
            label: 'Beautify Titles',
            action: setBeautify
        },
        {
            customComponent: writeModeComponent
        },
        {
            customComponent: dateFormatComponent
        }
    ];

    return (
        <SettingsPanel
            filtersTitle="Metadata Fields"
            filtersComponent={metadataFieldsComponent}
            title="Settings"
            settings={settings}
            sliceSelector={(state) => state.fixMetadata}
            showFilterSeparator={true}
            settingsFirst={true}
        />
    );
};

export default FixMetadataSettings;
